import { useRef } from 'react'
import { useState, useEffect } from 'react';
import FormInput from '../components/FormInput';
import '../css/Contact.css';
import reference from "../img/random.jpg"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import emailjs from '@emailjs/browser';

export default function Contact() {
  useEffect(() => {
    document.title = "Kontakt";
  });

useEffect(() => {
  setSubmitted(false);
}, []);

  const [count, setCount] = useState(0);
  const [submitted, setSubmitted] = useState(false); // New state to track submission
  const form = useRef();
  const [inputValues, setInputValues] = useState({
    name: "",
    mobile: "",
    email: "",
    message: ""
  });
  const [isDisabled, setIsDisabled] = useState(false);

  const inputs = [
    {
      id: 1,
      name: "name",
      type: "text",
      placeholder: "Namn/Företag",
      errorMessage: "Ditt namn och/eller företag behöver innehålla minst två bokstäver!",
      label: "Namn/Företag*",
      minLength: 2,
      maxLength: 80,
      required: true,
    },
    {
      id: 2,
      name: "mobile",
      type: "number",
      placeholder: "Mobil/Telefon",
      label: "Mobil/Telefon"
    },
    {
      id: 3,
      name: "email",
      type: "email",
      placeholder: "Email",
      errorMessage: "Ange en giltig email adress!",
      label: "Email*",
      required: true
    },
    {
      id: 4,
      name: "message",
      type: "text",
      inputtype: "textarea",
      placeholder: "Meddelande",
      errorMessage: "Meddelande krävs!",
      label: "Meddelande*",
      required: true,
      maxLength: 500
    }
  ];

const handleSubmit = async (e) => {
  e.preventDefault();

  if (form.current.checkValidity()) {

    const templateParams = {
      name: inputValues.name,
      email: inputValues.email,
      mobile: inputValues.mobile,
      message: capitalizeFirstLetter(inputValues.message),
    };

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        templateParams,
        process.env.REACT_APP_EMAILJS_API_KEY
      )
      .then(
        (result) => {
          toast.success('Ditt email har skickats!', {
            position: 'top-right'
          });

          setInputValues({
            name: "",
            mobile: "",
            email: "",
            message: ""
          });

          setSubmitted(true);
          setIsDisabled(true);

          setTimeout(() => {
            setIsDisabled(false);
          }, 5000);
        },
        (error) => {
          console.error('Error:', error);
          toast.error('Något gick fel!', {
            position: 'top-right'
          });
        }
      );

  } else {
    toast.error('Formuläret är inte giltigt. Kontrollera dina fält.');
  }
};

  const onChange = (e) => {
    setInputValues({ ...inputValues, [e.target.name]: e.target.value });
    if (e.target.name === "message")
      setCount(e.target.value.length)
  };

  const preventEkey = (e) => {
    if (e.target.name === "mobile")
      if (e.key === 'e' || e.key === 'E') {
        e.preventDefault();
      }
  }

  const handleInvalid = (event) => {
    event.target.setCustomValidity('Fyll i fältet!');
  };

  // Reset custom validity when the input changes
  const handleInput = (event) => {
    event.target.setCustomValidity('');
  };

  const capitalizeFirstLetter = (text) => {
  if (!text) return "";
  return text.charAt(0).toUpperCase() + text.slice(1);
};

  return (
    <>
      <form ref={form} className='px-lg-6 px-4' style={{ backgroundImage: `url(${reference})`, backgroundSize: 'cover', backgroundPosition: 'center', position: 'relative' }} onSubmit={handleSubmit}>
        <div className='form-container bg-grey my-4 grid-container'>
          <h2>Skicka ett meddelande</h2>
          <p>Vänligen fyll i formuläret nedan för att komma i kontakt med oss.</p>
          {inputs.map((input) => (
            <FormInput key={input.id} {...input} value={inputValues[input.name]} onChange={onChange} count={count} onKeyDown={preventEkey} onInvalid={handleInvalid} onInput={handleInput}
              submitted={submitted} />
          ))
          }
          <button type='submit' disabled={isDisabled} className='btn btn-primary custom-btn mb-3 bg-blue'>Skicka</button>
        </div>
      </form>
      <ToastContainer />
    </>
  )
}